// ** React Imports
import { useState, useEffect, MouseEvent, useCallback, ReactElement } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import Grid from '@mui/material/Grid'
import { DataGrid, GridEventListener } from '@mui/x-data-grid';
import Typography from '@mui/material/Typography'
import Icon from 'src/features/common/CustomIcon'
import Link from '@mui/material/Link';
// ** Store Imports
import { SelectOption } from 'src/types/common';
import RefreshTwoToneIcon from '@mui/icons-material/RefreshTwoTone';
// ** Custom Components Imports
import Tooltip from '@mui/material/Tooltip'
import { client } from 'src/utils/axios-client'
import { leadEndpoints } from 'src/configs/endpoints'

import _, { now } from 'lodash'
import { ActivityDashboardDialogStore, ActivityType, CadenceListDialogStore, DashboardViewStore, InboundCallStore, Lead, LeadActivity, LeadActivityDashboard, LeadActivityDashboardStore, LeadActivityStore, LeadListStore, LeadScreenStore, QuickLeadDialogStore, ViewType } from '../../stores/LeadStore'
import { ActivityColor, colorDateTooltipOverdue, colorDateTooltipOverdueDashboard, nextDateDays, nextDateDaysDashboard } from '../../utils/date-utils'
import { DataGridPro } from '@mui/x-data-grid-pro/DataGridPro'
import LeadDataFormater from '../leads/view/LeadDataFormater'
import IconButton from '@mui/material/IconButton';
import ArrowBackTwoToneIcon from '@mui/icons-material/ArrowBackTwoTone';
import DateTimeDisplay from '../common/DateTimeDisplay';
import { red } from '@mui/material/colors';
import LocalFireDepartmentTwoTone from '@mui/icons-material/LocalFireDepartmentTwoTone';
import CheckIcon from '@mui/icons-material/Check';
import { error } from 'console';
import GridSkeleton from '../common/GridSkeleton';
import CustomChip from 'src/materio/@core/components/mui/chip'
import ReactAudioPlayer from 'react-audio-player';


interface CellType {
    row: LeadActivityDashboard
}

type Props = {
    customerId: string,
    activityDate: string,
    activityType: string,
    title: string,
    userId: string
}

const ActivityDashboardList = ({ customerId, activityDate, activityType, title, userId }: Props) => {
    const [pageSize, setPageSize] = useState(10000);
    const [value, setValue] = useState<string>('')
    const [reloadRecords, setReloadRecords] = useState<boolean>(false)
    const list = LeadActivityDashboardStore.useState(s => s.items);
    const [filteredList, setFilteredList] = useState([] as LeadActivityDashboard[])
    const showTodoList = DashboardViewStore.useState(s => s.showTodoList);
    const [hasLoaded, setHasLoaded] = useState<boolean>(false)

    useEffect(() => {
        setHasLoaded(false);
        loadRecords(customerId, activityDate, activityType, title, userId);
    }, [reloadRecords, showTodoList])

    useEffect(() => {
        setFilteredList(list);
    }, [list, value])

    const loadRecords = async (customerId: string, activityDate: string, activityType: string, title: string, userId: string) => {
        const response = await client.get(leadEndpoints.getactivitydashboardlist, { params: { customerId, activityDate, activityType, title, userId } });
        LeadActivityDashboardStore.update(s => { s.items = response.data });
        setHasLoaded(true);

    }

    //const viewCadenceSteps = (lead: Lead) => {
    //    LeadScreenStore.update(s => { s.selectedLead = lead });
    //    CadenceListDialogStore.update(s => { s.cadenceListDialogMode = true })
    //};

    //const viewQuickLead = (lead: Lead) => {
    //    LeadScreenStore.update(s => { s.selectedLead = lead });
    //    QuickLeadDialogStore.update(s => { s.quickLeadDialogMode = true })
    //};

    //const onExecuteActivity = (lead: Lead) => {
    //    InboundCallStore.update(s => { s.showPhoneControls = false })
    //    LeadScreenStore.update(s => { s.selectedLead = lead; s.selectedView = ViewType.DoActivity; s.editMode = false })
    //};

    const reload = () => {
        if (reloadRecords) {
            setReloadRecords(false);
        }
        else {
            setReloadRecords(true);
        }
    };

    const goBack = () => {
        DashboardViewStore.update(s => { s.activityDate = '' });
        DashboardViewStore.update(s => { s.showActivityHistoryList = false });
        DashboardViewStore.update(s => { s.showTodoList = true });
        DashboardViewStore.update(s => { s.showActivityWorkList = false });
        DashboardViewStore.update(s => { s.showInboundCallList = false });
        DashboardViewStore.update(s => { s.showDefault = true });
        DashboardViewStore.update(s => { s.showDetail = false });
        DashboardViewStore.update(s => { s.showTaskList = false });
        
    };

    //const setActionButton = (date: Date) => {
    //    const now = new Date();

    //    var timeDifference = Math.floor((date.getTime() - now.getTime()));
    //    var dayDifference = timeDifference / (1000 * 3600 * 24);

    //    dayDifference = Math.round(dayDifference);

    //    if (dayDifference > 1) {
    //        return true;
    //    }
    //    else if (dayDifference == 1) {
    //        return true;
    //    }
    //    return false;
    //};

    const viewQuickLead = (lead: Lead) => {
        LeadScreenStore.update(s => { s.selectedLead = lead });
        QuickLeadDialogStore.update(s => { s.quickLeadDialogMode = true })
    };

    const viewNotes = (text: string) => {
        ActivityDashboardDialogStore.update(s => { s.notesText = text });
        ActivityDashboardDialogStore.update(s => { s.notesDiealogMode = true })
    };

    const viewEmail = (text: string) => {
        ActivityDashboardDialogStore.update(s => { s.emailBodyText = text });
        ActivityDashboardDialogStore.update(s => { s.emailBodyDiealogMode = true })
    };

    const viewSMS = (text: string) => {
        ActivityDashboardDialogStore.update(s => { s.smsBodyText = text });
        ActivityDashboardDialogStore.update(s => { s.smsBodyDiealogMode = true })
    };

    const viewSocialMedia = (text: string) => {
        ActivityDashboardDialogStore.update(s => { s.socialMediaText = text });
        ActivityDashboardDialogStore.update(s => { s.socialMediaDiealogMode = true })
    };

    const columns = [
        {
            flex: 0.1,
            minWidth: 130,
            field: 'currentActivityDate',
            headerName: 'Date',
            hideable: false,
            valueGetter: ({ row }: CellType) => row.currentActivityDate,
            renderCell: ({ row }: CellType) => {
                const { activityId } = row
                return (
                    <Box sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', alignItems: 'left' }}>
                            <Typography variant="caption" >
                                <DateTimeDisplay value={row.currentActivityDate} format={"date"} />
                            </Typography>
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 200,
            field: 'currentActivityName',
            headerName: 'Activity',
            valueGetter: ({ row }: CellType) => row.currentActivityName,
            hideable: false,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.currentActivityName} textColor='' errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 200,
            field: 'leadFullName',
            headerName: 'Lead',
            valueGetter: ({ row }: CellType) => row.leadFullName,
            hideable: false,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Link
                            sx={{ color: 'text.primary', textDecoration: 'none' }}
                            underline="hover"
                            component="button"
                            variant="caption"
                            onClick={() => viewQuickLead(row.lead)}
                        >
                            {row.leadFullName}
                        </Link>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 160,
            field: 'currentActivityOwnerName',
            headerName: 'Owner',
            valueGetter: ({ row }: CellType) => row.currentActivityOwnerName,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.currentActivityOwnerName} textColor='' errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 200,
            field: 'notes',
            headerName: 'Activity Notes',
            valueGetter: ({ row }: CellType) => row.notes,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {row.notes != "" &&
                            <Link
                                sx={{ color: 'text.primary', textDecoration: 'none' }}
                                underline="hover"
                                component="button"
                                variant="caption"
                                onClick={() => viewNotes(row.notes)}
                            >
                                Click to view
                            </Link>
                        }
                        {row.notes == "" &&
                            <CustomChip
                                skin='light'
                                size='small'
                                label='Not Entered'
                                sx={{
                                    height: '20',
                                    fontSize: '0.75rem',
                                    fontWeight: '500',
                                    borderRadius: '5px',
                                    textTransform: 'capitalize',
                                    color: 'dimgrey',
                                    alignItems: 'center'
                                }}
                            />
                        }
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 200,
            field: 'currentStageName',
            headerName: 'Original Stage',
            valueGetter: ({ row }: CellType) => row.currentStageName,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.currentStageName} textColor={row.currentStageColor} errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 200,
            field: 'nextStageName',
            headerName: 'New Stage',
            valueGetter: ({ row }: CellType) => row.nextStageName,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.nextStageName} textColor={row.nextStageColor} errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 200,
            field: 'currentActivityOutcomeName',
            headerName: 'Outcome',
            valueGetter: ({ row }: CellType) => row.currentActivityOutcomeName,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.currentActivityOutcomeName} textColor={row.currentActivityOutcomeButtonColor} errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 200,
            field: 'sprintName',
            headerName: 'Sprint',
            valueGetter: ({ row }: CellType) => row.sprintName,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.sprintName} textColor='' errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 200,
            field: 'currentCadenceName',
            headerName: 'Cadence',
            valueGetter: ({ row }: CellType) => row.currentCadenceName,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.currentCadenceName} textColor='' errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 160,
            field: 'currentCadenceStep',
            headerName: 'Cadence Step',
            valueGetter: ({ row }: CellType) => row.currentCadenceStep,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.currentCadenceStep} textColor='' errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 200,
            field: 'nextActivityName',
            headerName: 'Next Activity',
            valueGetter: ({ row }: CellType) => row.nextActivityName,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.nextActivityName} textColor='' errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 160,
            field: 'nextActivityDate',
            headerName: 'Next Activity Date',
            valueGetter: ({ row }: CellType) => row.nextActivityDate,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            {row.nextActivityDate != "" &&
                                <Typography variant="caption" >
                                    <DateTimeDisplay value={row.nextActivityDate} format={"date"} />
                                </Typography>
                            }       
                            {row.nextActivityDate == "" &&
                                <CustomChip
                                    skin='light'
                                    size='small'
                                    label='N/A'
                                    sx={{
                                        height: '20',
                                        fontSize: '0.75rem',
                                        fontWeight: '500',
                                        borderRadius: '5px',
                                        textTransform: 'capitalize',
                                        color: 'dimgrey',
                                        alignItems: 'center'
                                    }}
                                />
                            }
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 200,
            field: 'nextCadenceName',
            headerName: 'Next Cadence',
            valueGetter: ({ row }: CellType) => row.nextCadenceName,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.nextCadenceName} textColor='' errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 160,
            field: 'nextCadenceStep',
            headerName: 'Next Cadence Step',
            valueGetter: ({ row }: CellType) => row.nextCadenceStep,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.nextCadenceStep} textColor='' errorText='-Unknown-' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 140,
            field: 'phoneTo',
            headerName: 'Number Called',
            valueGetter: ({ row }: CellType) => row.phoneTo,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.phoneTo} textColor='' errorText='N/A' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 120,
            field: 'phoneFrom',
            headerName: 'Called From',
            valueGetter: ({ row }: CellType) => row.phoneFrom,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.phoneFrom} textColor='' errorText='N/A' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 120,
            field: 'smsBody',
            headerName: 'SMS Message',
            valueGetter: ({ row }: CellType) => row.smsBody,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {row.smsBody != "" &&
                            <Link
                                sx={{ color: 'text.primary', textDecoration: 'none' }}
                                underline="hover"
                                component="button"
                                variant="caption"
                                onClick={() => viewSMS(row.smsBody)}
                            >
                                Click to view
                            </Link>
                        }
                        {row.smsBody == "" &&
                            <CustomChip
                                skin='light'
                                size='small'
                                label='N/A'
                                sx={{
                                    height: '20',
                                    fontSize: '0.75rem',
                                    fontWeight: '500',
                                    borderRadius: '5px',
                                    textTransform: 'capitalize',
                                    color: 'dimgrey',
                                    alignItems: 'center'
                                }}
                            />
                        }
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 140,
            field: 'callStatus',
            headerName: 'Call Status',
            valueGetter: ({ row }: CellType) => row.callStatus,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.callStatus} textColor='' errorText='N/A' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 160,
            field: 'callStartTime',
            headerName: 'Call Start Time',
            valueGetter: ({ row }: CellType) => row.callStartTime,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.callStartTime} textColor='' errorText='N/A' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 130,
            field: 'durationSeconds',
            headerName: 'Call Duration',
            valueGetter: ({ row }: CellType) => row.durationSeconds,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            {row.durationSeconds != ' (seconds)' &&
                                <LeadDataFormater labelText='' valueText={row.durationSeconds} textColor='' errorText='N/A' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                            }
                            {row.durationSeconds == ' (seconds)' &&
                                <CustomChip
                                    skin='light'
                                    size='small'
                                    label='N/A'
                                    sx={{
                                        height: '20',
                                        fontSize: '0.75rem',
                                        fontWeight: '500',
                                        borderRadius: '5px',
                                        textTransform: 'capitalize',
                                        color: 'dimgrey',
                                        alignItems: 'center'
                                    }}
                                />
                        }
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 120,
            field: 'callCost',
            headerName: 'Call Cost',
            valueGetter: ({ row }: CellType) => row.callCost,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            {row.callCost != '$' &&
                                <LeadDataFormater labelText='' valueText={row.callCost} textColor='' errorText='N/A' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                            }
                            {row.callCost == '$' &&
                                <CustomChip
                                    skin='light'
                                    size='small'
                                    label='N/A'
                                    sx={{
                                        height: '20',
                                        fontSize: '0.75rem',
                                        fontWeight: '500',
                                        borderRadius: '5px',
                                        textTransform: 'capitalize',
                                        color: 'dimgrey',
                                        alignItems: 'center'
                                    }}
                                />
                            }
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 350,
            field: 'recording',
            headerName: 'Call Recording',
            valueGetter: ({ row }: CellType) => row.recording,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            {row.recording != "" &&
                                <ReactAudioPlayer
                                    src={row.recording}
                                    controls={true}
                                />
                            }
                            {row.recording == "" &&
                                <CustomChip
                                    skin='light'
                                    size='small'
                                    label='N/A'
                                    sx={{
                                        height: '20',
                                        fontSize: '0.75rem',
                                        fontWeight: '500',
                                        borderRadius: '5px',
                                        textTransform: 'capitalize',
                                        color: 'dimgrey',
                                        alignItems: 'center'
                                    }}
                                />
                            }
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 200,
            field: 'emailFrom',
            headerName: 'Email From',
            valueGetter: ({ row }: CellType) => row.emailFrom,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.emailFrom} textColor='' errorText='N/A' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 200,
            field: 'emailTo',
            headerName: 'Email To',
            valueGetter: ({ row }: CellType) => row.emailTo,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.emailTo} textColor='' errorText='N/A' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 230,
            field: 'emailSubject',
            headerName: 'Email Subject',
            valueGetter: ({ row }: CellType) => row.emailSubject,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.emailSubject} textColor='' errorText='N/A' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 140,
            field: 'emailBody',
            headerName: 'Email Body',
            valueGetter: ({ row }: CellType) => row.emailBody,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {row.emailBody != "" &&
                            <Link
                                sx={{ color: 'text.primary', textDecoration: 'none' }}
                                underline="hover"
                                component="button"
                                variant="caption"
                                onClick={() => viewEmail(row.emailBody)}
                            >
                                Click to view
                            </Link>
                        }
                        {row.emailBody == "" &&
                            <CustomChip
                                skin='light'
                                size='small'
                                label='N/A'
                                sx={{
                                    height: '20',
                                    fontSize: '0.75rem',
                                    fontWeight: '500',
                                    borderRadius: '5px',
                                    textTransform: 'capitalize',
                                    color: 'dimgrey',
                                    alignItems: 'center'
                                }}
                            />
                        }
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 200,
            field: 'socialMediaPlatform',
            headerName: 'Social Media Platform',
            valueGetter: ({ row }: CellType) => row.socialMediaPlatform,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.socialMediaPlatform} textColor='' errorText='N/A' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 220,
            field: 'socialMediaUsername',
            headerName: 'Social Media Account Name',
            valueGetter: ({ row }: CellType) => row.socialMediaUsername,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column' }}>
                            <LeadDataFormater labelText='' valueText={row.socialMediaUsername} textColor='' errorText='N/A' chipHeight={20} chipFontSize='0.75rem' chipfontWeight={500} isChip={false} />
                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 1,
            minWidth: 200,
            field: 'socialMediaBody',
            headerName: 'Social Media Body',
            valueGetter: ({ row }: CellType) => row.socialMediaBody,
            hideable: true,
            renderCell: ({ row }: CellType) => {
                const { id, fullName } = row

                return (
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        {row.socialMediaBody != "" &&
                            <Link
                                sx={{ color: 'text.primary', textDecoration: 'none' }}
                                underline="hover"
                                component="button"
                                variant="caption"
                                onClick={() => viewSocialMedia(row.socialMediaBody)}
                            >
                                Click to view
                            </Link>
                        }
                        {row.socialMediaBody == "" &&
                            <CustomChip
                                skin='light'
                                size='small'
                                label='Not Entered'
                                sx={{
                                    height: '20',
                                    fontSize: '0.75rem',
                                    fontWeight: '500',
                                    borderRadius: '5px',
                                    textTransform: 'capitalize',
                                    color: 'dimgrey',
                                    alignItems: 'center'
                                }}
                            />
                        }
                    </Box>
                )
            }
        },
        {
            flex: 0.9,
            minWidth: 100,
            field: 'hasMI',
            headerName: 'MI',
            valueGetter: ({ row }: CellType) => row.hasMI,
            renderCell: ({ row }: CellType) => {

                return (
                    <Box sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', alignItems: 'left' }}>
                            {row.hasMI ?
                                <CheckIcon color="success" />
                                :
                                ""
                            }

                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 0.9,
            minWidth: 100,
            field: 'hasMQL',
            headerName: 'MQL',
            valueGetter: ({ row }: CellType) => row.hasMQL,
            renderCell: ({ row }: CellType) => {

                return (
                    <Box sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', alignItems: 'left' }}>
                            {row.hasMQL ?
                                <CheckIcon color="success" />
                                :
                                ""
                            }

                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 0.9,
            minWidth: 100,
            field: 'hasDC',
            headerName: 'DC',
            valueGetter: ({ row }: CellType) => row.hasDC,
            renderCell: ({ row }: CellType) => {

                return (
                    <Box sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', alignItems: 'left' }}>
                            {row.hasDC ?
                                <CheckIcon color="success" />
                                :
                                ""
                            }

                        </Box>
                    </Box>
                )
            }
        },
        {
            flex: 0.9,
            minWidth: 100,
            field: 'hasOPP',
            headerName: 'Opportunity',
            valueGetter: ({ row }: CellType) => row.hasOPP,
            renderCell: ({ row }: CellType) => {

                return (
                    <Box sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
                        <Box sx={{ display: 'flex', alignItems: 'left' }}>
                            {row.hasOPP ?
                                <CheckIcon color="success" />
                                :
                                ""
                            }

                        </Box>
                    </Box>
                )
            }
        },
    ];

    const handleFilter = useCallback((val: string) => {
        setValue(val)
    }, [])


    if (!hasLoaded) return <GridSkeleton />;

    return (
        <Card sx={{ width: '100%' }}>
            <Box sx={{ p: 5, pb: 3, display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{ mr: 4, mb: 2 }}>
                    <Tooltip title="Go Back" >
                        <IconButton aria-label="Go Back to Dashboard" onClick={() => goBack()} >
                            <ArrowBackTwoToneIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
                <Box sx={{ mr: 4, mb: 2 }}>
                    <Typography sx={{ fontSize: 20, color: 'CornflowerBlue' }} gutterBottom>
                        {title}
                    </Typography>
                </Box>

                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                    <Tooltip title="Refresh" >
                        <IconButton aria-label="Next activity" onClick={() => reload()} >
                            <RefreshTwoToneIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>

            <DataGridPro
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            // Hide columns
                            currentActivityOwnerName: false,
                            sprintName: false,
                            currentCadenceName: false,
                            currentCadenceStep: false,
                            nextActivityName: false,
                            nextActivityDate: false,
                            nextCadenceName: false,
                            nextCadenceStep: false,
                            phoneTo: false,
                            phoneFrom: false,
                            smsBody: false,
                            callStatus: false,
                            callStartTime: false,
                            durationSeconds: false,
                            callCost: false,
                            recording: false,
                            emailFrom: false,
                            emailTo: false,
                            emailSubject: false,
                            emailBody: false,
                            socialMediaPlatform: false,
                            socialMediaUsername: false,
                            socialMediaBody: false,
                            hasMI: false,
                            hasMQL: false,
                            hasDC: false,
                            hasOPP: false
                        },
                    },
                }}
                autoHeight
                pagination={false}
                rows={filteredList}
                columns={columns}
                //pageSize={pageSize}
                disableSelectionOnClick

            //rowsPerPageOptions={[5, 10, 25, 50]}
            //rowCount={list.totalCount}
            //paginationMode="server"
            //onPageChange={(newPage: number) => loadRecords(newPage, pageSize, activityDate, startDate, endDate, userId, activityName)}
            //onPageSizeChange={(newPageSize: number) => setPageSize(newPageSize)}

            />




        </Card>
    )


}

export { ActivityDashboardList }
export default ActivityDashboardList
